import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // tanks_counts
  async count_tanks_station(data) {
    let response = await apiCall("fuel_tanks/count_fuel_tanks", data);
    return response;
  },
  async count_tanks_company(data) {
    let response = await apiCall("fuel_tanks/count_company_fuel_tanks", data);
    return response;
  },
  // pumps_counts
  async count_pumps_station(data) {
    let response = await apiCall("fuel_pumps/count_fuel_station_pumps", data);
    return response;
  },
  async count_pumps_company(data) {
    let response = await apiCall("fuel_pumps/count_fuel_company_pumps", data);
    return response;
  },
  // users_counts
  async count_all_users(data) {
    let response = await apiCall("users/count", data);
    return response;
  },
  async count_users_company(data) {
    let response = await apiCall("users/count_fuel_company_users", data);
    return response;
  },
  async count_users_station(data) {
    let response = await apiCall("users/count_fuel_station_users", data);
    return response;
  },
  // sum_sales
  async company_fuel_sale_sums(data) {
    let response = await apiCall("fuel_sales/company_fuel_sale_sums", data);
    return response;
  },
  async station_month_sales_sum_ups(data) {
    let response = await apiCall(
      "fuel_sales/station_month_sales_sum_ups",
      data
    );
    return response;
  },
  //count_company_stations
  async count_station(data) {
    let response = await apiCall("stations/count_station", data);
    return response;
  },
};
